module.exports = __webpack_public_path__ + "media/images/form-status-revision-accepted-7e044189.gif";